module.exports = __webpack_public_path__ + "static/media/pf29.38fea35f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf29.png
// module id = 2662
// module chunks = 0